import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import CloseIcon from '../../../Icons/CloseBold';
import CollectionPanel from '../../../CollectionPanel';
import IconButton from '../../../Button/IconButton';
import { IconSize } from '../../../Icons/IconWrap';
import { scrollIntoViewWithHeader } from '../../../utils/scrollIntoViewWithHeader';
import AddToGroupsPanel from '../../../AddToGroupsPanel';
import { BiLoggerContextProvider } from '../../../biLogger/BiLogger.context';
import s from './PanelPopup.scss';
export var PanelPopup = function (_a) {
    var visiblePanel = _a.visiblePanel, deviation = _a.deviation, className = _a.className, onClose = _a.onClose;
    var rootRef = useRef(null);
    var prevPanel = useRef(false);
    useEffect(function () {
        function onExpandTransitionEnd() {
            if (!rootRef.current) {
                return;
            }
            rootRef.current.removeEventListener('transitionend', onExpandTransitionEnd);
            scrollIntoViewWithHeader(rootRef.current);
        }
        if (!prevPanel.current && visiblePanel && rootRef.current) {
            rootRef.current.addEventListener('transitionend', onExpandTransitionEnd);
        }
        prevPanel.current = visiblePanel;
        var rootCurrent = rootRef.current;
        return function () {
            rootCurrent &&
                rootCurrent.removeEventListener('transitionend', onExpandTransitionEnd);
        };
    }, [visiblePanel, rootRef, prevPanel]);
    return (React.createElement("div", { ref: rootRef, className: classnames(s['root'], visiblePanel && s['visible'], className) },
        visiblePanel !== 'collection' && (React.createElement(IconButton, { className: s['close'], onClick: onClose },
            React.createElement(CloseIcon, { size: IconSize.MEDIUM }))),
        React.createElement("div", { className: s['panel'] },
            visiblePanel === 'collection' && (React.createElement(CollectionPanel, { collectibleDeviation: deviation })),
            visiblePanel === 'groups' && (React.createElement(BiLoggerContextProvider, { value: { deviationid: deviation.deviationId } },
                React.createElement(AddToGroupsPanel, { deviation: deviation }))))));
};
PanelPopup.displayName = 'PanelPopup';
export default PanelPopup;
//# sourceMappingURL=PanelPopup.js.map